import { ChBaseModule } from './../ch-base/ch-base.module';
import { RouterModule } from '@angular/router';
import { ChPasswordComponent } from './ch-password.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../../shared/translate/translate.module';

@NgModule({
  declarations: [ChPasswordComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ChBaseModule,
    IonicModule,
    TranslateModule,
  ],
  exports: [
    ChPasswordComponent
  ]
})
export class ChPasswordModule { }
